import { createFileRoute } from '@tanstack/react-router';

import { BlogCategoriesPage, blogCategoriesQueryOptions } from '@/features/blog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blog/categories')({
  staticData: { crumb: 'common:nav.blogCategories', tours: ['content.blog-categories'] },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...blogCategoriesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: BlogCategoriesPage,
});
